import { enumBoxHeightMode } from "../constants";

export function StringCodeToVSizingMode(strCode) {
  switch (strCode) {
    case "autoself":
      return enumBoxHeightMode.autoself;
      break;
    case "autosmart":
      return enumBoxHeightMode.autosmart;
      break;
  }

  return enumBoxHeightMode.fixedheight;
}
